import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

export const DropZone = ({ onFile, busy, testId, hint }) => {
  const ref = useRef(null);
  const [over, setOver] = useState(false);
  const pick = (f) => f && onFile(f);
  return (
    <div
      data-testid={testId}
      onClick={() => ref.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); pick(e.dataTransfer.files?.[0]); }}
      className={`flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed px-6 py-10 text-center transition-colors duration-150 ${
        over ? "border-sky-400 bg-sky-500/10" : "border-slate-700 hover:border-slate-500 hover:bg-slate-800/30"
      }`}
    >
      <UploadCloud className={`h-8 w-8 ${busy ? "animate-pulse text-sky-400" : "text-slate-500"}`} />
      <div className="text-sm text-slate-200">{busy ? "Reading file…" : "Drop a file here or click to choose"}</div>
      <div className="text-xs text-slate-500">{hint}</div>
      <input
        ref={ref}
        data-testid={`${testId}-input`}
        type="file"
        accept=".xlsx,.xlsm,.csv,.txt"
        className="hidden"
        onChange={(e) => { pick(e.target.files?.[0]); e.target.value = ""; }}
      />
    </div>
  );
};
